export const buildUrl = (
  url: string,
  base?: string | URL,
  searchParams?: Record<string, string | null | undefined>,
) => {
  const newUrl = new URL(url, base);

  if (searchParams) {
    const newSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(searchParams)) {
      if (value) {
        newSearchParams.append(key, value);
      }
    }

    newUrl.search = newSearchParams.toString();
  }

  return newUrl;
};

export function appendSearchParams(
  path: string,
  params: Record<string, string | null | undefined>,
) {
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      searchParams.append(key, value);
    }
  }

  if (searchParams.size > 0) {
    return `${path}?${searchParams.toString()}`;
  }

  return path;
}
